//chapter1
export default {
    id : 12,//chapter number
    title : '12. DFMEA 작성방법 (5) - DFMEA 위험분석',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            source : 'c12.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            body1 : [
                'DFMEA 위험분석',
            ],
            body2 : [
                'DFMEA 위험분석에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            source : '12.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    question : '심각도의 판정은 발생정도에 의해 결정된다.',//html available
                    answer : "2",
                    explain : '심각도는 고장영향에 의해 결정된다.'
                },
                {
                    type : 'ox',
                    question : '검출도는 고장원인과 고장형태를 검출하는 능력이다.',//html available
                    answer : "1",
                    explain : '검출도의 대상은 원인과 고장형태이다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            /*download : 'sample.pptx',//data folder*/
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <h3>1. 위험분석 개요</h3>
                        <li>Risk 분석의 목적은 심각도, 발생도, 검출도에 의해 Risk를 평가하여 필요한 조치를 순서화 하는 것임</li>
                        <p class="mg10"></p>
                        <h3>2. 현설계 관리의 이해</h3>
                        <li>예방방법과 검출방법 이해</li>
                        <p class="mg10"></p>
                        <h3>3. 심각도, 발생도, 검출도와 평가방법</h3>
                        <p class="mg10"></p>
                        <h3>4. AP 평가 방법</h3>
                        <p class="mg10"></p>
                        <h3>5. 양식 사용방법</h3>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'c12.mp4',
        },
    ]
}